riot.tag2('app', '<page></page>', 'section{padding-top:1rem;padding-bottom:1rem}dt{font-weight:bold;margin-top:.2em}h4{margin-top:1em !important}', '', function(opts) {
(function() {
  var base;

  base = location.pathname.replace(/[^\/]*(\?.*)?(#.*)?$/, '');

  riot.route.base(base);

  riot.route((function(_this) {
    return function(filename, search) {
      var href;
      if (filename !== '') {
        href = location.href;
        history.back();
        location.href = href;
        return void 0;
      }
      $('#menu-button').sideNav('hide');
      if (location.search === '') {
        riot.route('?' + location.hash);
      }
      search = location.search;
      if (search[0] === '?') {
        search = search.slice(1);
      }
      if (!search) {
        search = 'index';
      }
      if ($('page').attr('riot-tag') !== 'page-' + search) {
        $('#menu-button').sideNav('destroy');
        if (filename !== "" || riot.mount('page', 'page-' + search).length === 0) {
          riot.mount('page', 'page-404');
        }
      }
      if (!location.hash) {
        return window.scrollTo(0, 0);
      } else {
        return location.hash = location.hash;
      }
    };
  })(this));

  riot.route.start(true);

(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');ga('create', 'UA-40046179-3', 'auto');ga('send', 'pageview');
;

}).call(this);
});



//////////////////
// WEBPACK FOOTER
// ./src/scripts/app.tag.slim
// module id = 31
// module chunks = 0